import { ReactNode, useMemo } from 'react';
import { FieldValues, useFormState } from 'react-hook-form';
import { ValidationMessagesMap } from '../../utils/ValidationMessagesMap';
import { ErrorAlertWithDrawer } from '../../components/ErrorAlertWithDrawer';
import { FormValidationAlert } from './FormValidationAlert';

export interface AdditionalErrors {
  errorAction?: string;
  renderErrorHeading?: (name: string) => ReactNode;
  errors: ValidationMessagesMap;
  onClose?: () => void;
}

export interface FormAlertProps {
  tLabel?: (name: string | string[]) => ReactNode;
  additionalErrors?: AdditionalErrors[];
  view?: string;
  errorAction?: string;
}

export const FormAlerts = <FormData extends FieldValues>(
  props: FormAlertProps,
) => {
  const { tLabel, additionalErrors, errorAction } = props;
  const { errors } = useFormState<FormData>();

  const validationMessagesMap = useMemo(
    () => ValidationMessagesMap.fromFieldErrors(errors),
    [errors],
  );

  return (
    <>
      {additionalErrors?.map(
        ({ errorAction, renderErrorHeading, errors, onClose }, index) => (
          <ErrorAlertWithDrawer
            key={index}
            errorAction={errorAction}
            renderErrorHeading={renderErrorHeading}
            validationMessagesMap={errors}
            closable={!!onClose}
            onClose={onClose}
          />
        ),
      )}
      <FormValidationAlert
        tLabel={tLabel}
        validationMessagesMap={validationMessagesMap}
        errorAction={errorAction}
      />
    </>
  );
};
